import { DocumentInfo } from 'api';
import { TextField } from 'form';
import { Box, Grid, SectionContainer } from 'ui';

import { AddDocumentInMemoryButton, DocumentList } from '~/document';

type Props = {
  uploadedDocuments: DocumentInfo[];
};

export const BuyerAdditionalDetailsAndDocumentsSection = ({ uploadedDocuments }: Props) => {
  return (
    <>
      <SectionContainer title="Additional Details and Documents">
        <TextField
          name="external_reference_number"
          label="Purchaser's external reference (indent)"
          type="text"
          fullWidth
          infoTooltip="Purchaser's contract number or Purchaser's own internal sales reference"
        />
        <TextField
          name="comments"
          label="Comments on the SO"
          type="text"
          fullWidth
          minRows={2}
          multiline
          infoTooltip="Additional information that will be displayed on the SO PDF."
        />
        <TextField
          name="internal_notes"
          label="Internal notes"
          type="text"
          fullWidth
          minRows={2}
          multiline
          infoTooltip="Additional information to be shared with Safi teams. "
        />
      </SectionContainer>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <AddDocumentInMemoryButton name="documents" />
          </Grid>
        </Grid>
        <Grid container spacing={2} pt={4}>
          <Grid item xs={12} md={4}>
            <DocumentList name="documents" uploadedDocuments={uploadedDocuments} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
